import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PlaceBetContent from './place-bet-content.js';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * View for displaying related calculations and the place bet button.
 *
 * @class PlaceBetContent
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * PlaceBetContent prop types.
 *
 * @property {Mojito.Services.Betslip.types.Calculation} calculation - Betslip calculation.
 * @property {string} [currencyCode] - Currency code to use in betslip.
 * @property {Mojito.Services.Betslip.types.COMMIT_BETSLIP_MODE} [commitBetslipMode] - Commit betslip mode, indicating whether user can place a bet or save for later placement in a shop.
 * @property {boolean} [isSuspended = false] - Defines whether the place bet content is suspended.
 * @property {boolean} [placeBetButtonDisabled = false] - Determines if the place bet button is disabled.
 * @property {node} [children] - The content to display between betslip notifications and calculations area.
 * @property {boolean} [hasBetslipChanges = false] - Indicates the presence of non-accepted changes on betslip level, such as price or handicap changes.
 * @property {Array<Mojito.Services.Betslip.types.Error>} [placementErrors = []] - An array of placement errors, typically multiplier errors.
 * @property {Mojito.Services.Betslip.types.BETSLIP_STATUS} [betslipStatus] - The current betslip status.
 * @property {Function} [onOpenSettingsCallback = () => {}] - Callback triggered when settings are opened.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.BetslipView.PlaceBetContent
 */
const propTypes = {
    calculation: PropTypes.object.isRequired,
    commitBetslipMode: PropTypes.string,
    currencyCode: PropTypes.string,
    isSuspended: PropTypes.bool,
    placeBetButtonDisabled: PropTypes.bool,
    children: PropTypes.node,
    hasBetslipChanges: PropTypes.bool,
    placementErrors: PropTypes.array,
    betslipStatus: PropTypes.string,
    onOpenSettingsCallback: PropTypes.func,
    class: PropTypes.string,
};

const defaultProps = {
    isSuspended: false,
    placeBetButtonDisabled: false,
    hasBetslipChanges: false,
    placementErrors: [],
    onOpenSettingsCallback: noop,
};

export default UIView('PlaceBetContent', PlaceBetContent, propTypes, defaultProps);
